import React, { FC } from 'react';
import { TeamMemberItem } from './TeamMemberItem';
import { useStore } from '@/app/providers/StoreProvider';
import { ITeam } from '../types';
import { isCaptain } from '@/shared/utils/users';

interface TeamMemberListProps{
  team: ITeam | null,
  minHeight: boolean
}

export const TeamMemberList:FC<TeamMemberListProps> = ({team, minHeight}) => {
  const {userStore} = useStore();
  const {user} = userStore;
  const myId = user.id;
  
  if(!team){
    return null
  }

  return (
      <div className='team-members'>
        <p className='team-members_text'>Участники:</p>
        <div className={`team-members_list ${minHeight?'minHeight':''}`}>
          {
            team.members.map((member, index)=>(
              index < 10 || member.userId == myId?
                <TeamMemberItem place={index+1} member={member} leader={isCaptain(myId,team.members)??false} key={member.userId}/>
              :null
            ))
          }
        </div>
      </div>


  );

};